module.exports = __webpack_public_path__ + "assets/img/ZT8669-M.f5f1dd65.png";